export const postalToOption = postal => ({
  label : postal?.name,
  value : postal?.id,
})

export { PostalsPanel } from './panel'
